var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "3000px",
    height: "2000px",
    viewBox: "0 0 3000 2000",
    style: {
      enableBackground: "new 0 0 3000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.pt0{fill:#F6F5F5;}\n\t.pt1{fill:#DADADA;}\n\t.pt2{fill:#D3DFFF;}\n\t.pt3{fill:#FFFFFF;}\n\t.pt4{fill:#86A7FF;}\n\t.pt5{fill:#ADC3FF;}\n\t.pt6{fill:#E5ECFF;}\n\t.pt7{fill:#F9B384;}\n\t.pt8{fill:#102048;}\n\t.st9{fill:#EB5D60;}\n\t.pt10{fill:#7D69ED;}\n\t.pt11{fill:#E28B6D;}\n\t.pt12{fill:#5B4DAD;}\n\t.pt13{fill:#FBC343;}\n\t.pt14{fill:#E49B31;}\n\t.pt15{fill:#1F3C88;}\n\t.pt16{fill:#3A6BEA;}\n\t.pt17{opacity:0.3;fill:#102048;}\n\t.pt18{fill:#AB4446;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt0",
    d: "M2598.4,1003.6c-110.3-79.4-242.4-117.9-364.1-175.4c-117-55.3-200.2-144.3-304.9-217.5 c-171-119.7-368.7-209.5-569.9-264.3c-203.4-55.4-452-86.1-637.4,36.7c-91.2,60.4-165.4,154.1-195.7,259.9 c-36,125.9-0.8,254.5,16.5,380.3c14,102.2-51.6,158.6-128.9,216.7c-181,136-176,382.1-64.1,558.5h2330.1 C2818.2,1547.7,2879.1,1205.9,2598.4,1003.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "pt0",
    cx: 361.4,
    cy: 1016.4,
    r: 86.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "pt0",
    cx: 2406.5,
    cy: 587.8,
    r: 127.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1562 -0.9877 0.9877 0.1562 -461.0227 1037.8102)",
    className: "pt0",
    cx: 376.9,
    cy: 788.7,
    rx: 38.3,
    ry: 38.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -119.2474 1020.4237)",
    className: "pt0",
    cx: 2505.4,
    cy: 810,
    rx: 38.3,
    ry: 38.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt1",
    d: "M272.1,1792.5c-110.8-94.5-111.8-260-63.7-381.9c53.6-135.8,179.3-247.7,344.8-306.8c4-1.4,8-2.8,12.1-4.2 l1.5,4.3c-4,1.4-8,2.8-12,4.2c-164.3,58.7-288.9,169.5-342.1,304.2c-47.6,120.5-46.7,283.7,62.4,376.8L272.1,1792.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt1",
    d: "M2604.4,1797.8l-4-2.1c81.8-159.1,130.3-319.5,140.2-463.9c9.7-142.4-18.5-259.8-81.7-339.6 c-57.3-72.4-171.4-147.4-389.3-93.2l-1.1-4.4c220.2-54.7,335.8,21.4,393.9,94.8c63.9,80.7,92.5,199.2,82.6,342.7 C2735.1,1477.1,2686.5,1638.1,2604.4,1797.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt1",
    d: "M782.6,526l-4.4-1.1c0.3-1.2,7.8-29.7,32.8-67.4c23-34.7,65.9-83.8,139.3-120.8 c84.1-42.4,189.9-60.4,314.6-53.4c156,8.7,342,56.6,552.8,142.4l-1.7,4.2c-210.4-85.6-395.9-133.4-551.4-142 c-123.9-6.9-228.9,10.9-312.3,53c-72.5,36.6-114.8,85-137.5,119.3C790.1,497.1,782.6,525.8,782.6,526z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt2",
    d: "M2387.4,558.3V1702c0,16-13,28.9-28.9,28.9H733.1c-16,0-28.9-13-28.9-28.9V558.3c0-16,13-28.9,28.9-28.9 h1625.4C2374.5,529.4,2387.4,542.3,2387.4,558.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 755.3,
    y: 625,
    className: "pt3",
    width: 1581,
    height: 958.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M2338.6,1585.7H753.1v-963h1585.5V1585.7z M757.6,1581.1H2334V627.3H757.6V1581.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 755.3,
    y: 565.4,
    className: "pt3",
    width: 1581,
    height: 59.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M2338.6,627.3H753.1v-64.1h1585.5V627.3z M757.6,622.7H2334v-55.1H757.6V622.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M829.7,609c-7.6,0-13.8-6.2-13.8-13.8c0-7.6,6.2-13.8,13.8-13.8c7.6,0,13.8,6.2,13.8,13.8 C843.4,602.8,837.2,609,829.7,609z M829.7,586c-5.1,0-9.2,4.1-9.2,9.2c0,5.1,4.1,9.2,9.2,9.2c5.1,0,9.2-4.1,9.2-9.2 C838.9,590.1,834.7,586,829.7,586z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M875.6,609c-7.6,0-13.8-6.2-13.8-13.8c0-7.6,6.2-13.8,13.8-13.8s13.8,6.2,13.8,13.8 C889.4,602.8,883.2,609,875.6,609z M875.6,586c-5.1,0-9.2,4.1-9.2,9.2c0,5.1,4.1,9.2,9.2,9.2s9.2-4.1,9.2-9.2 C884.9,590.1,880.7,586,875.6,586z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M921.6,609c-7.6,0-13.8-6.2-13.8-13.8c0-7.6,6.2-13.8,13.8-13.8s13.8,6.2,13.8,13.8 C935.4,602.8,929.2,609,921.6,609z M921.6,586c-5.1,0-9.2,4.1-9.2,9.2c0,5.1,4.1,9.2,9.2,9.2s9.2-4.1,9.2-9.2 C930.8,590.1,926.7,586,921.6,586z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 621.2,
    y: 1712.8,
    className: "pt2",
    width: 1849.2,
    height: 85.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M2473,1801.1H618.7v-90.9H2473V1801.1z M623.8,1796h1844.1v-80.7H623.8V1796z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt3",
    d: "M1627.2,1672.1h-162.8c-10.2,0-18.5-8.3-18.5-18.5v-11c0-10.2,8.3-18.5,18.5-18.5h162.8 c10.2,0,18.5,8.3,18.5,18.5v11C1645.7,1663.8,1637.4,1672.1,1627.2,1672.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M1624.7,1674.4h-157.8c-12.8,0-23.3-10.4-23.3-23.3v-6c0-12.8,10.4-23.3,23.3-23.3h157.8 c12.8,0,23.3,10.4,23.3,23.3v6C1648,1663.9,1637.5,1674.4,1624.7,1674.4z M1466.9,1626.4c-10.3,0-18.7,8.4-18.7,18.7v6 c0,10.3,8.4,18.7,18.7,18.7h157.8c10.3,0,18.7-8.4,18.7-18.7v-6c0-10.3-8.4-18.7-18.7-18.7H1466.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M2112.2,1047.5H979.5c-40.9,0-74.2-33.3-74.2-74.2v-5c0-40.9,33.3-74.2,74.2-74.2h1132.7 c40.9,0,74.2,33.3,74.2,74.2v5C2186.4,1014.2,2153.1,1047.5,2112.2,1047.5z M979.5,898.6c-38.4,0-69.7,31.3-69.7,69.7v5 c0,38.4,31.3,69.7,69.7,69.7h1132.7c38.4,0,69.7-31.3,69.7-69.7v-5c0-38.4-31.3-69.7-69.7-69.7H979.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt2",
    d: "M1113.9,998.6H977c-12.6,0-22.9-10.3-22.9-22.9v-9.8c0-12.6,10.3-22.9,22.9-22.9h137 c12.6,0,22.9,10.3,22.9,22.9v9.8C1136.8,988.3,1126.5,998.6,1113.9,998.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt2",
    d: "M1335.8,998.6h-119.7c-12.7,0-23.2-10.4-23.2-23.2v-9.2c0-12.7,10.4-23.2,23.2-23.2h119.7 c12.7,0,23.2,10.4,23.2,23.2v9.2C1359,988.1,1348.6,998.6,1335.8,998.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt2",
    d: "M1591,998.6h-161.3c-13.4,0-24.4-11-24.4-24.4v-6.7c0-13.4,11-24.4,24.4-24.4H1591 c13.4,0,24.4,11,24.4,24.4v6.7C1615.4,987.6,1604.4,998.6,1591,998.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt2",
    d: "M1945.1,998.3h-239.7c-13.4,0-24.4-11-24.4-24.4v-6.7c0-13.4,11-24.4,24.4-24.4h239.7 c13.4,0,24.4,11,24.4,24.4v6.7C1969.5,987.3,1958.5,998.3,1945.1,998.3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1354.9,
    y: 778.9,
    className: "pt4",
    width: 381.8,
    height: 40
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1417.9,
    y: 1290.9,
    className: "pt5",
    width: 67.7,
    height: 129.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1557.5,
    y: 1213.9,
    className: "pt2",
    width: 67.7,
    height: 206.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1697,
    y: 1168.5,
    className: "pt5",
    width: 67.7,
    height: 252
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1836.5,
    y: 1278.1,
    className: "pt2",
    width: 67.7,
    height: 142.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1976.1,
    y: 1195.9,
    className: "pt5",
    width: 67.7,
    height: 224.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2115.6,
    y: 1110.6,
    className: "pt2",
    width: 67.7,
    height: 309.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 887.3,
    y: 1102.7,
    className: "pt6",
    width: 381.8,
    height: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 887.3,
    y: 1171.2,
    className: "pt6",
    width: 381.8,
    height: 249.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M1095.6,1263.8c-14.4-5.7-29.2-1.2-39.7,9.1c-9.6,9.4-11,22.7-15.5,34.5c9.4,2.6,17.8,8.1,28,6.5 c13.2-2.1,13.6-14.4,21.1-22.8c6.4-7.2,14.1-11.9,23.3-13.1C1108.8,1272.3,1103.9,1267.2,1095.6,1263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M1203.7,1250.9c-13,2.8-26.7,7.5-36,17c-8,8.2-7.7,22.4-13.5,30.9c6.6,4.4,13.9,6.4,21.1,2.5 c7-3.8,11.3-12.3,18.9-16.1c6.1-3,14.8-4.9,21.5-6.1c1.5-0.3,3.1-0.4,4.6-0.7v-30.3C1214.7,1248.9,1209.2,1249.7,1203.7,1250.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt5",
    d: "M1215.7,1279.2c-6.6,1.2-15.4,3.1-21.5,6.1c-7.6,3.7-11.8,12.3-18.9,16.1c-7.2,3.9-14.6,1.8-21.1-2.5 c-2.6-1.7-5-3.8-7.3-6c-9-8.8-11.8-13.8-25.9-15c-2.9-0.2-5.6-0.1-8.3,0.2c-9.2,1.2-16.9,5.9-23.3,13.1 c-7.5,8.4-7.9,20.8-21.1,22.8c-10.2,1.6-18.6-3.9-28-6.5c-3.7-1-7.6-1.6-11.8-1c-9.9,1.4-16.1,7.3-23,11.8 c-4.8,3.1-9.9,5.6-16.7,5.3c-15.3-0.7-35-9.5-52.6-10v68.1h284.1v-103C1218.7,1278.7,1217.2,1278.9,1215.7,1279.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M1005.6,1318.3c-1.1-1-2.2-2-3.1-3.2c-7-8.7-7.6-19.8-15.4-28c-15.2-15.9-35.8-9.6-50.8,3.9v22.5 c17.6,0.6,37.3,9.4,52.6,10C995.7,1323.8,1000.8,1321.4,1005.6,1318.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt7",
    d: "M595.4,1156.2l-72.6,14.2l16.6-106.8l44.6,0.9c-0.3,1.9-0.6,3.7-0.7,5.6c-1.7,14.3-0.8,28.8,1,41.6 C587.9,1137,595.4,1156.2,595.4,1156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt8",
    d: "M584.3,1111.8c-27.9-13.2-38.3-40.8-38.3-40.8l37.2-0.9C581.6,1084.5,582.4,1098.9,584.3,1111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt7",
    d: "M599.6,1002.9c2.8,10,19,73.1-10.4,80.2c-29.4,7.1-59.8-19.9-59.8-19.9l10-60.7l42.7-12.8L599.6,1002.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M560.6,1037.2c0,0,7.6-50.5,39-34.3c-1.1-0.6-2.7-5.6-3.4-6.8c-3.2-5.2-7.2-9.9-12.1-13.5 c-17.8-13.1-47.9-8.3-62.2,6.7c-14.2,14.8-14.6,41.1-7.3,60.2c1.2,3.1,2.7,6.1,4.5,8.8c1.6,2.5,3.6,4.6,5.7,6.7 c1.9,1.8,15.8,12.8,16,4.3C541,1048.8,560.6,1037.2,560.6,1037.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7741 -0.6331 0.6331 0.7741 -530.4147 587.4005)",
    className: "pt7",
    cx: 557.8,
    cy: 1036.8,
    rx: 12.5,
    ry: 15.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "pt7",
    cx: 605.5,
    cy: 1038.8,
    rx: 6.6,
    ry: 7.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt8",
    d: "M510.4,1568l-86.4,37c0,0,71.2,181.2,92,192.6c20.9,11.4,10.4-89.2,24.7-119.6l18-71.2L510.4,1568z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.5,
    y: 1658,
    transform: "matrix(6.935371e-02 -0.9976 0.9976 6.935371e-02 -1186.8715 2081.2388)",
    className: "pt3",
    width: 9.1,
    height: 37.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "pt10",
    d: "M488.6,1554.7l52.2,123.4c0,0,203.1-106.3,253.4-203.1l-79.7-104.4L488.6,1554.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt8",
    d: "M760.9,1654.3c0,0,94.9,3.8,138.5-71.2l-96.8-14.2L760.9,1654.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "pt7",
    points: "909.4,1667.3 802.3,1705.1 793.7,1674.6 778,1619.2 867.2,1577 873.5,1590.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pt8",
    points: "1044.7,1798.6 927.5,1706 909.4,1667.3 802.3,1705.1 828.8,1798.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 895.8,
    y: 1716.9,
    transform: "matrix(0.6173 -0.7867 0.7867 0.6173 -1004.0217 1378.9982)",
    className: "pt3",
    width: 39.2,
    height: 9.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pt11",
    points: "873.5,1590.5 793.7,1674.6 778,1619.2 867.2,1577  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "pt10",
    d: "M899.5,1583.1c-50.5,12.7-96.6,36.5-138.5,71.2l-72.1-189.8c0,0-145.5,138.7-232.5,115.8 c-82.6-21.8-46.5-158.5-46.5-158.5c113.4-79.4,293.8-186,372.9-101.6c0.4,0.4,0.7,0.7,1,1c16.2,17.8,34.5,52.9,51.6,91.8 C869.6,1490.6,899.5,1583.1,899.5,1583.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt12",
    d: "M835.4,1413.1c-78.6,18.5-159.5-68.9-159.5-68.9l81.3-26.7l25.6,2.7c0.4,0.4,0.7,0.7,1,1 C799.9,1339,818.2,1374.2,835.4,1413.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt12",
    d: "M758.8,1655.1l-70.9-186.6c-15.4,14.6-99.1,91.2-187.3,114.4l-1.2-4.4c96-25.3,186.8-114.8,187.7-115.7 l2.5-2.5l73.4,193L758.8,1655.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt13",
    d: "M526.8,1116.5l-31.9,103L452,1358.1c0,0-31.3,11.2-58.9,7.7c-24.4-3.1-45.9-17.7-40-62 C365.9,1206.4,526.8,1116.5,526.8,1116.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt14",
    d: "M494.9,1219.5L452,1358.1c0,0-31.3,11.2-58.9,7.7c23.1-142.2,99.7-202.8,99.7-202.8L494.9,1219.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pt13",
    points: "838.5,1218.5 814.8,1308.9 734.7,1233.3 766.4,1180 809.4,1203  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pt7",
    points: "766.6,1180.1 797,1131.6 858.4,1105.4 838.3,1218.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt15",
    d: "M1065,1087.2c-16.1-3.9-30.7-3.2-43.8,1.6c-8.7,3.2-16.8,8.2-24.2,15l-29.7-68.8 c10.3-1.8,19.7-4.9,28.2-9.4c12.3-6.5,22.6-15.9,30.6-28.7L1065,1087.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pt15",
    points: "997,1103.8 967.4,1035 530.4,1242.4 546.2,1279 997,1103.8 967.4,1035  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt8",
    d: "M1065,1087.2c-16.1-3.9-30.7-3.2-43.8,1.6l-25.7-63.2c12.3-6.5,22.6-15.9,30.6-28.7L1065,1087.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -314.2217 1157.6226)",
    className: "pt15",
    cx: 1240.3,
    cy: 958.1,
    rx: 233.4,
    ry: 233.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -314.2216 1157.6226)",
    className: "pt3",
    cx: 1240.3,
    cy: 958.1,
    rx: 194.5,
    ry: 194.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M1063,878.2h354.5c-0.8-1.7-1.5-3.4-2.3-5.1h-349.8C1064.6,874.8,1063.7,876.5,1063,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt4",
    d: "M1416.9,1039.4h-353.3c0.8,1.7,1.5,3.4,2.4,5.1h348.5C1415.3,1042.8,1416.1,1041.1,1416.9,1039.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt2",
    d: "M1095,960.8v-4c0-16-13.1-29-29-29h-17.8c-3.2,20.3-3.3,41.2,0.2,62h17.7 C1082,989.8,1095,976.7,1095,960.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt2",
    d: "M1187.2,927.8c-16.2,0-29.4,13.2-29.4,29.4v3.2c0,16.2,13.2,29.4,29.4,29.4h126.7 c16.2,0,29.4-13.2,29.4-29.4v-3.2c0-16.2-13.2-29.4-29.4-29.4H1187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt2",
    d: "M1432.4,927.8h-6.5c-17,0-31,13.9-31,31c0,17,13.9,31,31,31h6.2C1435.5,969.5,1435.7,948.6,1432.4,927.8z "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "pt7",
    d: "M838.5,1218.5l-29.1-15.5l17.7-38.5c0,0,24.7-44.6,37-42.7C876.4,1123.6,838.5,1218.5,838.5,1218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt13",
    d: "M734.7,1233.3l-6,10.1c-12-16.5-38.5-51.7-71.8-79.7v0c-29.9-25.1-70.6-64.2-106.1-58.8 c-95,14.4-141,316.8-141,316.8l245.7-88.9l55,42.9c12,9.3,27,13.8,42.2,12.5h0c25.4-2.2,46.7-20.2,53.1-44.8l9-34.5 L734.7,1233.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.9,
    y: 1258.8,
    transform: "matrix(0.6632 -0.7484 0.7484 0.6632 -765.8901 904.5674)",
    className: "pt14",
    width: 4.5,
    height: 89.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.8,
    y: 1229,
    transform: "matrix(0.8167 -0.5771 0.5771 0.8167 -593.2832 659.9722)",
    className: "pt14",
    width: 4.5,
    height: 69.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt11",
    d: "M1979.1,646.5c0,0-11.5,36-40.5,52s-67.5,33-54.5,38.5c13,5.5,47.7,2,47.7,2s-67.2,52-48.2,57.5 c19,5.5,65-32,65-32s-6.2,14,3.2,17c9.5,3,27.7-0.5,27.7-0.5s-2.5,10,16.5,7.5c19-2.5,68.5-62.5,68.5-62.5l3.5-55L1979.1,646.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt16",
    d: "M1920.6,337.6c0,0,75-19.5,187.4,51c101.2,63.4,107.9,125.9,60,203.9c-48,78-103.5,133.4-103.5,133.4 l-85.5-79.5l75-116.9L1920.6,337.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt16",
    d: "M1894.1,349.6c0,0-105.9,57-159.9,179.9H2104l-102-161.9L1894.1,349.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt11",
    d: "M1789.8,529c0,0,36.4,6.4,49.1,0c12.7-6.4-27.7-24.7-62.6-33.4c-34.9-8.6-75.7-24-109.4,24 c-33.7,48-30.4,51.4-19.5,50.6c10.9-0.7,36.7-33,36.7-33s-27.7,34.9-14.6,38.6c13.1,3.7,44.6-43.9,44.6-43.9s-27,38.6-13.1,43.1 c13.9,4.5,43.9-42.7,43.9-42.7s-30.4,47.6-12,46.5c12-0.7,25.6-21.6,33.8-36.1C1771.3,534.3,1780.2,529,1789.8,529L1789.8,529z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt8",
    d: "M1920,401.9c-14.4,0-25.8-6.2-26-6.3l2.2-4c1.5,0.8,37.1,20.1,60.1-15.7l3.8,2.5 C1948.2,397,1932.9,401.9,1920,401.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pt8",
    points: "1981,647.7 1977.2,645.2 2073.9,496.7 2036.8,438.8 2040.6,436.4 2079.3,496.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt11",
    d: "M1941.8,354.3c-6.1,21.7-35.2,26.3-48.6,8.1l-3.6-4.8l-23.1-31.3l23.8-30.9l2.3-3l5.4,4l3.9,2.9l41.5,31.1 C1944.4,340.1,1943.6,348,1941.8,354.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt8",
    d: "M1889.7,357.7l-23.1-31.3l23.8-30.9l7.7,1l3.7,0.5c0,0,0.1,0.8,0.2,2.4 C1902.6,307.5,1903.4,334.1,1889.7,357.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt11",
    d: "M1800.8,277.2c0,0,51.5,92.4,88.5,53.8c28.1-29.4,8.3-69.9,8.3-69.9l-27.3-26.5l-60.8,18.2L1800.8,277.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt13",
    d: "M1880.2,281.7c0,0-17.4-27.6-36.3-14.6c-18.9,13-41.2,48.1-67.1,27.8c-18.1-14.1-5.8-54.2,18.1-50.8 c0,0,26.4-50.6,71.7-37.2c45.3,13.3,27.9,40.3,52.1,44.4c24.2,4,102.6,9.7,89.5,92.5c0,0-33.5-8.9-61.5-5.8 c-35,3.9-58.6-53.8-58.6-53.8C1885.8,284.8,1880.2,281.7,1880.2,281.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "pt11",
    cx: 1884.6,
    cy: 279.5,
    rx: 13.6,
    ry: 17.7
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 1795,
    className: "pt8",
    width: 2741,
    height: 6.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2228.1,
    y: 1549.4,
    className: "pt15",
    width: 187.5,
    height: 109.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pt8",
    points: "2437.4,1798.2 2537.3,1848.4 2503.4,1718.4 2459.4,1710 2413.4,1726.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt16",
    d: "M2459.4,1710l-22,88.2c0,0-94.9-12.5-187.8-33.1c-42.9-9.5-85.3-20.7-117.9-33.2 c-17.1-6.6-31.5-13.5-41.8-20.8c-72.2-50.9-46.5-168.1,76-148.1c47.5,7.8,98.6,28.9,144.8,52.9c21,10.9,41,22.4,59.1,33.4 C2422.7,1681.4,2459.4,1710,2459.4,1710z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt17",
    d: "M2369.9,1649.2l-120.3,115.8c-42.9-9.5-85.3-20.7-117.9-33.2l179-116 C2331.8,1626.7,2351.8,1638.2,2369.9,1649.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "pt8",
    points: "2122.5,1725.9 2001.6,1796.2 2179.6,1795.4 2191,1727.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pt7",
    points: "2228.5,1710.5 2191,1727.9 2179.6,1795.4 2182,1795.4 2256.5,1796.4 2282.5,1763.9  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "pt16",
    d: "M2228.5,1710.5c0,0,141.9-138.9,264.9-171.9c114-30.6,147.9,84,84,140.9c-64,57-320.8,116.9-320.8,116.9 L2228.5,1710.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt8",
    d: "M2257,1798.6l-1.1-4.4c88.1-22.3,178.7-46.4,244.1-72.3l1.7,4.2C2436.1,1752.1,2345.3,1776.3,2257,1798.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt8",
    d: "M2314.2,1163.9c-12.8,1-24.8,4.2-35.4,11.7c-8.9,6.3-15.7,15.1-20,25c-6.8,15.4-5.2,32.7-10.4,48.5 c-5,15.2-17.2,23.1-28.7,33.2c-11,9.8-18.9,26-15,40.9c1.1,4.1,3.1,8,5.8,11.3c2,2.5,8.3,9.9,11.8,9.9c0,0,193,0.9,193,0.9 s35.9-33.6-5.4-72.9c-11.5-10.9-24.3-22.1-30.1-37.4c-3.6-9.5-5.4-19.4-8.1-29.2c-3.5-12.4-11.1-25-21.4-32.9 C2340,1165,2327,1162.9,2314.2,1163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt8",
    d: "M2298,1175.6c0,0-32.2-24.5-0.3-35.6c24.4-8.5,47.3,1.1,32.7,32.7L2298,1175.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2306.4,1298.4c0,0-181.4,30.7-217.4,155.9s183,133.3,183,133.3s215.1-7.4,253.3-41.8 s57.7-209.1-197.9-245.9L2306.4,1298.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt18",
    d: "M2318.1,1366.9c-1.2,0-2.3,0-3.5-0.1c-13-1.1-23.4-7.8-29.1-19l4-2.1c5,9.7,14,15.6,25.4,16.5 c14,1.2,29-5.3,36.7-15.7l3.7,2.7C2347.5,1359.9,2332.6,1366.9,2318.1,1366.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2197.1,
    y: 1422.2,
    transform: "matrix(0.6287 -0.7777 0.7777 0.6287 -336.7084 2261.1924)",
    className: "pt18",
    width: 4.5,
    height: 122
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2379.9,
    y: 1481.8,
    transform: "matrix(0.7561 -0.6545 0.6545 0.7561 -376.868 1957.0416)",
    className: "pt18",
    width: 114.4,
    height: 4.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "pt3",
    d: "M2410.9,1596H2222c-6.3,0-11.5-5.1-11.5-11.5v-131.7c0-6.3,5.1-11.5,11.5-11.5h188.8 c6.3,0,11.5,5.1,11.5,11.5v131.7C2422.4,1590.9,2417.2,1596,2410.9,1596z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pt7",
    d: "M2296.5,1259.6l-4.9,47c-0.9,9,2.6,17.9,9.5,23.6l0,0c9.4,7.8,22.7,7.9,32.2,0.2l0.4-0.4 c7.2-5.8,10.9-15.1,9.6-24.5l-6.1-46.8L2296.5,1259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt8",
    d: "M2295.6,1269.3c14.4,28.2,30.6,28.8,43,0.7l-25.5-3.3L2295.6,1269.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "pt7",
    cx: 2317.5,
    cy: 1234.6,
    rx: 34.4,
    ry: 45
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt8",
    d: "M2357.5,1227.2c0,0-34.5-0.6-45.8-28.5c0,0-18.5,6.5-23.3,30.5l-13.1,4.6l-0.3-37.6l29-18.5l25.9,0.6 l22.8,19.1L2357.5,1227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt7",
    d: "M2293.2,1230.9c3.8,7.4,1.9,16-4.4,19.3c-6.3,3.3-14.5-0.1-18.3-7.5c-3.8-7.4-1.9-16,4.4-19.3 C2281.1,1220.2,2289.3,1223.5,2293.2,1230.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pt7",
    d: "M2343,1230.9c-3.8,7.4-1.9,16,4.4,19.3c6.3,3.3,14.5-0.1,18.3-7.5s1.9-16-4.4-19.3 C2355.1,1220.2,2346.9,1223.5,2343,1230.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBill);
export default __webpack_public_path__ + "static/media/search_bill.91470e3d.svg";
export { ForwardRef as ReactComponent };